<div class="mainContainer {{navigationPage ? 'customNavigation': ''}}" >
     

    <div class="overlay"></div>
    <div class="sidePanel" *ngIf="!navigationPage">
        <a id="naviconLeft" href="#" class="navicon"><img src="assets/img/hamburgerIcon.png" alt=""></a>
        <div class="logoSec">
            <a href="#" class="logo">
                <span class="logoImg"><img src="assets/img/logo.png" alt=""></span>
                <!-- <span class="logoText"><img src="assets/img/logoText.png" alt=""></span> -->
                <span class="logoText">Workmate</span>
            </a>
        </div>
        <ul class="menu">
            <!-- <ng-container *ngIf="userData && userData.userType != userTypeMap.FIELD_USER"> -->
            <li class="closepanel" [routerLink]="['people']" routerLinkActive="active" *ngIf="userData && (userData.userType == userTypeMap.ADMIN || userData.userType == userTypeMap.MANAGER)">
                <a href="#">
                    <span class="menuIcon"><img src="assets/img/icon01.png" alt=""></span>
                    <span class="menuText">{{peopleText}}</span>
                </a>
            </li>
            <li class="closepanel" [routerLink]="['client']" routerLinkActive="active" *ngIf="userData && (userData.userType == userTypeMap.ADMIN || userData.userType == userTypeMap.MANAGER)">
                <a href="#">
                    <span class="menuIcon"><img src="assets/img/icon02.png" alt=""></span>
                <span class="menuText">{{clientText}}</span>
                </a>
            </li>
            <li class="closepanel" [routerLink]="['task']" routerLinkActive="active" *ngIf="userData && (userData.userType == userTypeMap.ADMIN || userData.userType == userTypeMap.MANAGER)">
                <a href="#">
                    <span class="menuIcon"><img src="assets/img/icon03.png" alt=""></span>
                    <span class="menuText">{{dashboardText}}</span>
                </a>
            </li>
           
            <li class="" routerLinkActive="active" *ngIf="userData && (userData.userType == userTypeMap.ADMIN || userData.userType == userTypeMap.MANAGER)">
                <a href="#"><span class="menuIcon"><img src="assets/img/icon05.png" alt=""></span><span class="menuText">{{reportText}}</span><span
                class="menuArrow"><i class="material-icons">keyboard_arrow_right</i></span></a>
                <div class="subNav">
                   <ul class="subNavList">
                      <li class="closepanel" [routerLink]="['report']" routerLinkActive="active">
                          <a href="#"><i class="material-icons-outlined">preview</i>View {{reportText}}</a></li>
                      <li class="closepanel" [routerLink]="['report/schedule-report']" routerLinkActive="active">
                          <a href="#"><i class="material-icons-outlined">schedule</i>Schedule {{reportText}}</a></li>
                   </ul>
                </div>
             </li>
             
             <li *ngIf="attendanceFeatureFlag" class="closepanel" [routerLink]="['attendance']" routerLinkActive="active">
                <a href="#">
                    <span class="menuIcon"><img src="assets/img/icon06.png" alt=""></span>
                    <span class="menuText">Attendance</span>
                </a>
            </li>

             <li class="" routerLinkActive="active" >
                 <a href="#"><span class="menuIcon"><img src="assets/img/icon07.png" alt=""></span><span class="menuText">Reimbursement</span><span
                class="menuArrow"><i class="material-icons">keyboard_arrow_right</i></span></a>
                <div class="subNav">
                   <ul class="subNavList">
                      <li class="closepanel" [routerLink]="['reimburse/activity']" routerLinkActive="active">
                          <a href="#"><i class="material-icons-outlined">pending_actions</i>Activity</a></li>
                      <li class="closepanel" [routerLink]="['reimburse/claim']" routerLinkActive="active">
                          <a href="#"><i class="material-icons-outlined">receipt_long</i>Claim</a></li>
                        <li class="closepanel" [routerLink]="['reimburse/status']" routerLinkActive="active">
                            <a href="#"><i class="material-icons-outlined">timelapse</i>Status</a></li>
                        <li *ngIf="userData && userData.userType != userTypeMap.FIELD_USER" class="closepanel" [routerLink]="['reimburse/approve']" routerLinkActive="active">
                            <a href="#"><i class="material-icons-outlined">check_circle_outline</i>Approve</a></li>
                   </ul>
                </div>
             </li>

           
            <li class="closepanel" [routerLink]="['form']" routerLinkActive="active">
                <a href="#">
                    <span class="menuIcon"><img src="assets/img/icon08.png" alt=""></span>
                    <span class="menuText">Forms</span>
                </a>
            </li>

            <li class="" routerLinkActive="active" *ngIf="userData && userData.userType == userTypeMap.ADMIN">
                <a href="#">
                    <span class="menuIcon"><img src="assets/img/icon04.png" alt=""></span>
                    <span class="menuText">{{manageText}}</span>
                    <span class="menuArrow"><i class="material-icons">keyboard_arrow_right</i></span>
            
                </a>
                <div class="subNav" >
                    <ul class="subNavList">

                        <li class="closepanel" [routerLink]="['manage/user-list']" routerLinkActive="active">
                            <a href="#"><i class="material-icons-outlined">people</i>User List</a></li>
                        <li class="closepanel" [routerLink]="['manage/user-group']" routerLinkActive="active">
                                <a href="#"><i class="material-icons-outlined">work_outline</i>User Group List</a></li>
                        <li class="closepanel" [routerLink]="['manage/client-list']" routerLinkActive="active">
                            <a href="#"><i class="material-icons-outlined">work_outline</i>{{clientText}} List</a></li>
                        <li class="closepanel" [routerLink]="['manage/custom-forms-list']" routerLinkActive="active">
                            <a href="#"><i class="material-icons-outlined">assignment</i>Custom Forms</a></li>
                        <li class="closepanel" [routerLink]="['manage/custom']" routerLinkActive="active">
                            <a href="#"><i class="material-icons-outlined">build</i>Custom</a></li>
                        <li class="closepanel" [routerLink]="['manage/company-settings']" routerLinkActive="active">
                            <a href="#"><i class="material-icons-outlined">domain</i>Company Settings</a></li>
                        <li *ngIf="attendanceFeatureFlag" class="closepanel" [routerLink]="['manage/attendance-leave-settings']" routerLinkActive="active">
                                <a href="#"><i class="material-icons-outlined">event</i>Attendance Settings</a></li>
                         <li  class="closepanel" [routerLink]="['manage/plan-upload']" routerLinkActive="active">
                                    <a href="#"><i class="material-icons-outlined">event</i>Plan bulk upload</a></li>

                    </ul>
                </div>
            </li>
            <li class="closepanel " [routerLink]="['field-user']" routerLinkActive="active" *ngIf="userData && userData.userType == userTypeMap.FIELD_USER">
                <a href="#">
                    <span class="menuIcon"><img src="assets/img/icon08.png" alt=""></span>
                    <span class="menuText">Mobile App</span>
                </a>
            </li>
<!-- </ng-container> -->
         

           
        </ul>
        
        <ul class="helpSec">
            <li><a href="#"><span class="icon"><img src="assets/img/helpIcon.png" alt=""></span><span class="text">Help</span><span
                        class="helpArrow"><i class="material-icons">keyboard_arrow_right</i></span></a>
        
                <div class="subNav singleSubNav">
                    <ul class="subNavList">
                        <!-- <li><a href="#"><i class="material-icons-outlined">account_tree</i>Take a Tour</a></li> -->
                        <li><a href="https://help.mappls.com/category/workmate/" target="_blank"><i class="material-icons-outlined">assignment</i>User
                                Manual</a></li>
                    </ul>
                </div>
        
            </li>
            <li class="profile">
                <a href="#">
                    <span class="icon">
                        <img *ngIf="!profilePic" src="assets/img/default.jpg" alt="">
                        <img *ngIf="profilePic" src="{{imageViewUrl}}{{profilePic}}" alt="">
        
                    </span>
                    <span class="text">{{userName | slice:0:11}}
                        <span *ngIf="userName.length >11">...</span>
                    </span>
                    <span class="helpArrow"><i class="material-icons">keyboard_arrow_right</i></span>
                </a>
                <div class="subNav">
                    <ul class="subNavList">
                        <!-- <li (click)="openFeedbackPanel();"><a href="#" id="fiterSecTrigger"><i class="material-icons-outlined">feedback</i>Feedback</a></li> -->
                        <li><a href="#" data-toggle="modal" data-target="#profileViewModal" ><i class="material-icons-outlined">perm_identity</i>Profile</a></li>
                        <li><a href="#" data-toggle="modal"  data-target="#switchAccModal" ><i class="material-icons-outlined">switch_account</i>Switch Account</a></li>
                        <li [routerLink]="['user/feedback']" routerLinkActive="active"><a href="#"><i class="material-icons-outlined">feedback</i>Feedback</a></li>
                        <li (click)="logout();"><a href="#"><i class="material-icons-outlined">power_settings_new</i>Logout</a></li>
                    </ul>
                </div>
        
            </li>
        </ul>
    </div>



    <router-outlet></router-outlet> 
   
</div>

<div class="bg-overlay"></div>


<div class="filter-sec" id="filterSec" [ngClass]="isFeedbackOpen ? 'filterSlide' : ''">
    <div class="filter-sec-head clearfix">
        <h2>Feedback</h2>
        <a href="#" class="close-btn" id="filterSecClose" (click)="closeFeedbackPanel();">
            <i class="material-icons">close</i>
        </a>
    </div>
    <div class="filter-sec-body clearfix">
        <div class="formContainer">
            <form action="#">
                <div class="feedbackSec">
                    <h4>Feedback Type</h4>
                    <ul class="feedbackList">
                        <li *ngFor="let type of feedbackTypeList">
                            <label>
                                <input type="radio" name="feedbackType" [value]="type" [(ngModel)]="selectedFeedbackType" />
                                {{type.text}}
                            </label>
                        </li>
                    </ul>
                </div>
                <div class="formSec">
                    <div class="form-group">
                        <div class="textAreaSec">
                            <textarea class="form-control" required name="description" [(ngModel)]="feedbackDescription"></textarea>
                            <div class="floating-label">Description*</div>
                        </div>

                    </div>
                </div>
                <div class="bulkuploadSec">
                    <h4>Images</h4>
                    <div class="upload-item">
                        <a href="#" class="upload-choose-files" (click)="onFileClick();">
                            <i class="material-icons-outlined">publish </i>
                            <span>Add files</span>
                        </a>
                        <input type="file" name="" id="feedback_file" (change)="onFileSelect()" style="display:none;" multiple>
                    </div>


                </div>
            </form>
        </div>
    </div>
    <div class="filter-sec-foot clearfix">
        <button type="button" class="btn btn-default ripple lineBlueBtn" (click)="closeFeedbackPanel();">Cancel</button>
        <button type="button" class="btn btn-default ripple blueBtn" (click)="submitFeedback()">Submit</button>
    </div>
</div>


<div id="docModal" class="modal fade customPopup" role="dialog">
    <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h3>{{docHeadingText}}</h3>

                <a href="#" class="close-btn" data-dismiss="modal" aria-hidden="true">
                    <i class="material-icons">close</i>
                </a>
            </div>
            <div class="modal-body">
                <ul class="documentlist">
                    <li *ngFor="let doc of docList">
                        <div class="docDiv">
                            <div class="docIcon"><img src="assets/img/attach2.png" alt=""></div>
                            <div class="docCont">
                                <p>{{doc.docName}} <span>{{doc.creationTime * 1000 |date: 'dd/MM/yy, hh:mm:ss'}}</span></p>
                            </div>
                        </div>
                        <a attr.href="{{downloadUrl}}{{doc.docId}}" class="docDown" ><i class="material-icons-outlined">cloud_download</i></a>
                    </li>
                    
                </ul>
            </div>

        </div>
    </div>
</div>

<!-- Modal -->
<div id="thumbModal" class="modal fade customPopup" role="dialog">
    <div class="modal-dialog modal-lg" >
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h3>{{imageHeadingText}}</h3>
                <!-- <a attr.href="{{downloadUrl}}{{downloadUrl}}" class="docDown"><i class="material-icons-outlined">cloud_download</i></a> -->
                <a href="#" class="close-btn" data-dismiss="modal" aria-hidden="true">
                    <i class="material-icons">close</i>
                </a>
            </div>
            <div class="modal-body" >
                <div class="bigscroll">
                <div class="bigImg">
                    
                    <div id="big" class="owl-carousel owl-theme">

                        <div class="item" *ngFor="let img of imageList, let i = index;" attr.index="{{i}}">
                            <img src="{{imageViewUrl}}{{img.docId}}" alt="">

                            <!-- <div class="imgCap left">
                                <p>{{img.docName}}</p>
                            </div> -->
                            <div class="imgCap right">
                                <p>{{i+1}}/{{imageList.length}}</p>
                            </div>
                            <a attr.href="{{downloadUrl}}{{img.docId}}" class="docDown"><i class="material-icons-outlined">cloud_download</i></a>
                        </div>

                    </div>

                    
                </div>
            </div>
                <div id="thumbs" *ngIf ="imageList.length >1" class="owl-carousel owl-theme">
                    <div class="item" *ngFor="let img of imageList">
                            <img src="{{imageViewUrl}}{{img.docId}}"alt="">
                    </div>
                  
                </div>
            </div>

        </div>
    </div>
</div>

<div id="orderModal" class="modal fade customPopup" role="dialog">
    <div class="modal-dialog modal-lg">
       <!-- Modal content-->
       <div class="modal-content">
          <div class="modal-header">
             <h3>{{formName}}</h3>
             <!-- <a href="#" class="docDown"><i class="material-icons-outlined">cloud_download</i></a> -->
           <a href="#" class="close-btn" data-dismiss="modal" aria-hidden="true">
             <i class="material-icons">close</i>
          </a>
          </div>
          <div class="modal-body">
             <div class="orderForm">
              
                    <div class="formDynamicInnerDiv">
                    
                <form id="fb-render" ></form>
            </div>
    
                <!-- <div class="orderDiv">
                   <h6>Enter the order details</h6>
                   <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
                </div>
                <div class="orderDiv">
                   <h6>Select the product Name</h6>
                   <span class="tagDiv">Product 1</span>
                   <span class="tagDiv">Product 2</span>
                   <span class="tagDiv">Product 3</span>
                </div>
                <div class="orderDiv">
                   <h6>Enter the product quantity</h6>
                   <p>1000</p>
                </div>
                <div class="orderDiv">
                   <h6>Product Size</h6>
                   <p>500 ML</p>
                </div>
                <div class="orderDiv">
                   <h6>Delivery Date</h6>
                   <p>31-08-2020</p>
                </div> -->
             </div>
          </div>

    </div>
 </div>
</div>


<div id="profileViewModal" class="modal fade customPopup profileViewModal" role="dialog">
    <div class="modal-dialog ">
       <!-- Modal content-->
       <div class="modal-content">
          <div class="modal-header">
             <h3>My Profile</h3>               
           <a href="#" class="close-btn" data-dismiss="modal" aria-hidden="true">
             <i class="material-icons">close</i>
          </a>
          </div>
          <div class="modal-body">
             <div class="orderForm">
                <div class="profilePicDiv">
                   <div class="profilePicSec">
                      <img *ngIf="profilePic" src="{{imageViewUrl}}{{profilePic}}" alt=""> 
                      <img *ngIf="!profilePic" src="assets/img/default.jpg" alt="">
                      <a href="#" class="cameraIcon" id="updateLink" >
                         <i class="material-icons">photo_camera</i>
                      </a>                          
                   </div>
                   <h4>{{userName}}</h4>
                   <div class="filterBox" id="filterUpdate">
                <h3>Change profile photo<a href="#" class="filterClose"><i class="material-icons">close</i></a></h3>
                <ul class="filterList" >
                   <li (click)="viewProfilePic();" ><i class="material-icons">photo_camera</i>View Photo</li>
                   <li (click)="pickProfilePic();"><i class="material-icons" >collections</i>Upload Profile Photo from Gallery</li>
                   <li (click)="removeProfilePic();" ><i class="material-icons">delete</i>Remove Profile Photo</li>                       
                </ul>
                <input type="file" name="profileFile" id="profile_file" (change)="onFileSelect()" style="display:none;">
             </div>
                </div>
                <div class="orderDiv">
                   <h6>Personal Information</h6>
                   <ul class="formDetailList">
                      
                      
                      <li>
                         <h5>Contact Number</h5>
                         <p>{{userData && userData.mobile ? userData.mobile : ''}}</p>
                      </li>
                      <li>
                         <h5>Employee Id</h5>
                         <p>{{userData && userData.employeeId ? userData.employeeId : ''}}</p>
                      </li>
                      <li>
                        <h5>Email Id</h5>
                        <!-- <p>{{userData && userData.emailId ? userData.emailId | slice:0:25 : ''}}</p> -->
                        <!-- <p>{{userData && userData.emailId.length > 25 ? ... }}</p> -->
                        <span *ngIf ="userData && userData.emailId">
                            <p>{{ userData.emailId | slice:0:25}} 
                                <span *ngIf ="userData.emailId.length > 25">...</span></p>
                           
                        </span>

                     </li>
                      
                   </ul>
                </div>
                <div class="orderDiv">
                   <h6>Manager information</h6>
                   <ul class="formDetailList">
                      
                      <li>
                         <h5>Manager Name</h5>
                         <p>{{managerInfo && managerInfo.name ? managerInfo.name : ''}}</p>
                      </li>
                    
                      <li>
                         <h5>Contact Number</h5>
                         <p>{{managerInfo && managerInfo.mobile ? managerInfo.mobile : ''}}</p>
                      </li>
                      <li>
                        <h5>Employee Id</h5>
                        <p>{{managerInfo && managerInfo.employeeId ? managerInfo.employeeId : ''}}</p>
                      </li>
                      <li>
                        <h5>Email Id</h5>
                        <!-- <p>{{managerInfo && managerInfo.emailId ? managerInfo.emailId : ''}}</p> -->
                        <span *ngIf ="managerInfo && managerInfo.emailId">
                            <p>{{ managerInfo.emailId | slice:0:25}} 
                                <span *ngIf ="managerInfo.emailId.length > 25">...</span></p>
                           
                        </span>
                     </li>
 
                   </ul>
                </div> 
                <div class="orderDiv ">
                    <h6>Account information</h6>
                    <ul class="coAccList">
                        <ng-container  *ngIf="userAccountList|customFieldsFilter: customFieldFilterObject as filteredList">
                       <li *ngFor="let userAccount of filteredList">
                           <!-- <ng-container *ngIf="userAccount.default"> -->
                          <!-- <div class="peopleText lgreen">{{userAccount.shortName}}<a class="dotStatusDiv greenDot tip1" href="#" alt=""  data-tip="tip-eight" data-placement="bottom"></a></div>
                          <div id="tip-eight" class="tip-content hidden" style="display: none;">
                                <div class="tooltipSec">
                                 
                                    <h2 >Account : <strong [ngClass]="userAccount.isActive ? 'green' : 'red'">{{userAccount.isActive ? 'Active': 'Expired'}}</strong></h2>
                                </div>
                             </div> -->
                          <div class="coAccText">
                             <span class="accNameText">{{userAccount.name}}</span>
                             <span class="accStatusText " [ngClass]="userAccount.isActive ? 'gStatusText' : 'rStatusText'">{{userAccount.isActive ? 'Active': 'Expired'}}</span>                              
                             <a href="#" class="deLink active" *ngIf="userAccount.default">Default</a>
                             <a href="#" class="deLink " *ngIf="!userAccount.default" (click)="makeDefaultAccount(userAccount);">Make as default</a>
                          </div>
                        <!-- </ng-container> -->
                       </li>
                    </ng-container>
                    </ul>
                    <!-- <button type="button" data-target="#switchAccModal" class="btn btn-default ripple blueBtn" >Switch Account</button> -->
                 </div>
             </div>
          </div>

    </div>
 </div>
</div>

<div id="switchAccModal" class="modal fade customPopup switchAccModal" role="dialog">
    <div class="modal-dialog ">
       <!-- Modal content-->
       <div class="modal-content">
          <div class="modal-header">
             <h3>Select Account</h3>
             <a href="#" class="close-btn" data-dismiss="modal" aria-hidden="true">
             <i class="material-icons">close</i>
             </a>
          </div>
          <div class="modal-body">
             <div class="orderForm">                     
                <ul class="coAccList">
                      <!-- <li *ngFor="let userAccount of userAccountList">
                         <div class="peopleText lgreen">{{userAccount.shortName}} <a class="dotStatusDiv greenDot tip1" href="#" alt=""  data-tip="tip-nine" data-placement="bottom"></a></div>
                         <div id="tip-nine" class="tip-content hidden" style="display: none;">
                               <div class="tooltipSec">
                                
                                  <h2 >Account : <strong [ngClass]="userAccount.isActive ? 'green' : 'red'">{{userAccount.isActive ? 'Active': 'Expired'}}</strong></h2>
                               </div>
                            </div>
                         <div class="coAccText">
                            <span class="accNameText"><a href='#'  (click)="openAccount(userAccount);">{{userAccount.name}}</a></span>
                            <span class="accLogoImg" *ngIf="userAccount.logo"><img src="{{imageViewUrl}}{{userAccount.logo}}" alt=""></span>
                            <a href="#" class="deLink active" *ngIf="userAccount.default">Default</a>
                            <a href="#" class="deLink " *ngIf="!userAccount.default" (click)="makeDefaultAccount(userAccount);">Make as default</a>
                         </div>
                      </li> -->
                      <li *ngFor="let userAccount of userAccountList">
                        <div class="coAccRadioBtn"><input type="radio" name="coAccRadioBtn" [value]="userAccount" [(ngModel)]="selectedAccount" (change)="openAccount(userAccount);" >
                            <!-- <input type="radio" name="coAccRadioBtn" *ngIf="!userAccount.default" > -->
                        </div>                           
                        <div class="coAccText">
                           <span class="accNameText"><a href='#'  (click)="openAccount(userAccount);">{{userAccount.name}}</a></span>
                           <span class="accStatusText " [ngClass]="userAccount.isActive ? 'gStatusText' : 'rStatusText'">{{userAccount.isActive ? 'Active': 'Expired'}}</span>                              
                           <a href="#" class="deLink active" *ngIf="userAccount.default">Default</a>
                            <a href="#" class="deLink " *ngIf="!userAccount.default" (click)="makeDefaultAccount(userAccount);">Make as default</a>
                        </div>
                     </li>
                      <!-- <li>
                         <div class="peopleText lyellow">CE<a class="dotStatusDiv redDot tip1" href="#" alt="" data-tip="tip-ten" data-placement="bottom"></a></div>
                          <div id="tip-ten" class="tip-content hidden" style="display: none;">
                               <div class="tooltipSec">
                                
                                  <h2>Account : <strong class="red">Expired</strong></h2>
                               </div>
                            </div>
                         <div class="coAccText">
                            <span class="accNameText">CE Info System</span>
                            <a href="#" class="deLink">Make as default</a>
                         </div>
                      </li> -->
                      <!-- <li>
                         <div class="peopleText lred">CI<a class="dotStatusDiv greenDot" href="#" alt=""></a></div>
                         <div class="coAccText">
                            <span class="accNameText">Covid Information</span>
                               
                            <a href="#" class="deLink">Make as default</a>
                         </div>
                      </li> -->
                   </ul>
                   <button type="button" class="btn btn-default ripple blueBtn" (click)="accountCreation()"><i class="material-icons">person_add_alt</i>Add Another Account</button>
             </div>
          </div>
       </div>
    </div>
 </div>